
import React from 'react';
import { useTranslation } from 'react-i18next';
import PendingInterviewsList from '@/components/interview/PendingInterviewsList';
import { Interview } from '@/types/interview';

interface ManagementContentProps {
  isLoading: boolean;
  error: unknown;
  pendingInterviews: Interview[] | undefined;
  onPublish: (interviewId: string) => Promise<void>;
  onReject: (interviewId: string) => Promise<void>;
}

export const ManagementContent: React.FC<ManagementContentProps> = ({
  isLoading,
  error,
  pendingInterviews,
  onPublish,
  onReject
}) => {
  const { t } = useTranslation();
  if (isLoading) {
    return (
      <div className="text-center py-8">
        <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent"></div>
        <p className="mt-4">{t('loading.pendingInterviews')}</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-red-700">
        {t('interviewManagement.messages.errorLoadingInterviews')} {error instanceof Error ? error.message : t('interviewManagement.messages.unknownError')}
      </div>
    );
  }

  return (
    <PendingInterviewsList 
      interviews={pendingInterviews || []} 
      onPublish={onPublish} 
      onReject={onReject}
    />
  );
};
